import React, { useState, useEffect } from 'react'
import { Checkdevice, Modcfm } from '../../../../components'
import { Retrieve_personal_info } from '../../../../config/commonfunctions'
import { READ_SC, USER_EDITSEATPASSCODE, CREATE_SC, REMOVE_SINGLESC } from './../../../../config/api'
import { Selectionbox } from '../Components'
import axios from 'axios'
import Continuepage from '../Components/Continuepage/Continuepage'
import Createnew from '../Components/Createnew/Createnew'

const etype_icon_map = {
    'Wedding': "M341.333333 85.333333a85.333333 85.333333 0 0 0 0 170.666667 85.333333 85.333333 0 0 0 0-170.666667z m277.333334 0a85.333333 85.333333 0 0 0 0 170.666667 85.333333 85.333333 0 0 0 0-170.666667z m106.752 128.042667s-2.24 40.384 21.290666 63.914667 63.914667 21.290667 63.914667 21.290666 2.197333-40.341333-21.333333-63.872c-23.530667-23.530667-63.872-21.333333-63.872-21.333333zM330.666667 298.666667a117.461333 117.461333 0 0 0-117.333334 117.333333v256c0 13.909333 8.938667 25.621333 21.333334 30.037333V906.666667a32 32 0 1 0 64 0V682.666667h85.333333v224a32 32 0 0 0 32 32h362.666667a32 32 0 0 0 32-32c0-213.269333-47.594667-319.616-64-349.909334V416a117.333333 117.333333 0 0 0-117.333334-117.333333h-39.68a149.952 149.952 0 0 0-128.576 73.344l-0.234666 0.405333A117.44 117.44 0 0 0 352 298.666667h-21.333333z m258.986666 64h39.68a53.333333 53.333333 0 0 1 53.333334 53.333333v149.333333c0 6.144 1.877333 12.373333 5.205333 17.536 0.554667 0.874667 53.354667 85.312 58.410667 291.797334H491.050667c5.034667-206.485333 57.813333-290.922667 58.410666-291.797334 3.328-5.162667 5.205333-11.392 5.205334-17.536v-100.053333l-81.344 137.685333a31.509333 31.509333 0 0 1-4.821334 5.973334 31.850667 31.850667 0 0 1-38.997333 5.312 32.042667 32.042667 0 0 1-11.264-43.882667L469.333333 483.882667l46.869334-79.296A85.674667 85.674667 0 0 1 589.674667 362.666667z",
    'Party': 'M234.666667 597.333333a21.333333 21.333333 0 0 1-21.333334-21.333333c0-85.76-10.197333-129.365333-36.437333-155.562667S107.093333 384 21.333333 384a21.333333 21.333333 0 0 1 0-42.666667c85.76 0 129.365333-10.197333 155.562667-36.437333S213.333333 235.093333 213.333333 149.333333a21.333333 21.333333 0 0 1 42.666667 0c0 85.76 10.197333 129.365333 36.437333 155.562667S362.24 341.333333 448 341.333333a21.333333 21.333333 0 0 1 0 42.666667c-85.76 0-129.365333 10.197333-155.562667 36.437333S256 490.24 256 576a21.333333 21.333333 0 0 1-21.333333 21.333333zM166.570667 362.666667c15.317333 6.912 28.842667 15.914667 40.533333 27.562666s20.650667 25.216 27.562667 40.533334c6.912-15.317333 15.914667-28.842667 27.562666-40.533334s25.216-20.650667 40.533334-27.562666c-15.317333-6.912-28.842667-15.914667-40.533334-27.562667s-20.650667-25.216-27.562666-40.533333c-6.912 15.317333-15.914667 28.842667-27.562667 40.533333s-25.216 20.650667-40.533333 27.562667zM490.666667 213.333333a21.333333 21.333333 0 0 1-21.333334-21.333333c0-29.696-3.242667-45.610667-10.837333-53.205333C450.944 131.242667 435.029333 128 405.333333 128a21.333333 21.333333 0 0 1 0-42.666667c29.696 0 45.610667-3.242667 53.205334-10.837333 7.552-7.552 10.794667-23.466667 10.794666-53.162667a21.333333 21.333333 0 0 1 42.666667 0c0 29.696 3.242667 45.610667 10.837333 53.205334 7.552 7.552 23.466667 10.794667 53.162667 10.794666a21.333333 21.333333 0 0 1 0 42.666667c-29.696 0-45.610667 3.242667-53.205333 10.837333-7.552 7.552-10.794667 23.466667-10.794667 53.162667a21.333333 21.333333 0 0 1-21.333333 21.333333zM106.666667 981.333333a21.333333 21.333333 0 0 1-21.333334-21.333333c0-29.696-3.242667-45.610667-10.837333-53.205333C66.944 899.242667 51.029333 896 21.333333 896a21.333333 21.333333 0 0 1 0-42.666667c29.696 0 45.610667-3.242667 53.205334-10.837333 7.552-7.552 10.794667-23.466667 10.794666-53.162667a21.333333 21.333333 0 0 1 42.666667 0c0 29.696 3.242667 45.610667 10.837333 53.205334 7.552 7.552 23.466667 10.794667 53.162667 10.794666a21.333333 21.333333 0 0 1 0 42.666667c-29.696 0-45.610667 3.242667-53.205333 10.837333-7.552 7.552-10.794667 23.466667-10.794667 53.162667a21.333333 21.333333 0 0 1-21.333333 21.333333zM874.666667 832a21.333333 21.333333 0 0 1-21.333334-21.333333c0-48.256-5.589333-73.557333-19.370666-87.296s-39.04-19.370667-87.296-19.370667a21.333333 21.333333 0 0 1 0-42.666667c48.256 0 73.557333-5.589333 87.296-19.370666S853.333333 602.922667 853.333333 554.666667a21.333333 21.333333 0 0 1 42.666667 0c0 48.256 5.589333 73.557333 19.370667 87.296s39.04 19.370667 87.296 19.370666a21.333333 21.333333 0 0 1 0 42.666667c-48.256 0-73.557333 5.589333-87.296 19.370667S896 762.410667 896 810.666667a21.333333 21.333333 0 0 1-21.333333 21.333333z m-23.296-149.333333a88.106667 88.106667 0 0 1 23.296 23.296 88.106667 88.106667 0 0 1 23.296-23.296 88.106667 88.106667 0 0 1-23.296-23.296 88.106667 88.106667 0 0 1-23.296 23.296zM758.4 442.965333a21.248 21.248 0 0 1-15.104-6.272C710.016 403.2 649.045333 384 576 384a21.333333 21.333333 0 0 1-21.333333-21.333333v-128a21.333333 21.333333 0 0 1 21.333333-21.333334C730.069333 213.333333 810.666667 288.469333 810.666667 362.666667c0 30.378667-13.226667 55.936-39.296 75.904a21.248 21.248 0 0 1-12.970667 4.394666zM597.333333 341.845333c66.261333 3.114667 121.984 20.778667 160.512 50.901334 6.954667-8.789333 10.154667-18.474667 10.154667-30.08 0-49.92-58.538667-100.437333-170.666667-106.154667v85.333333zM405.333333 1024a21.333333 21.333333 0 0 1-21.333333-21.333333v-128c0-50.730667 63.104-61.013333 129.92-71.893334 17.621333-2.858667 35.626667-5.76 52.693333-9.514666a21.333333 21.333333 0 0 1 9.088 41.685333c-17.749333 3.84-36.565333 6.954667-54.912 9.898667-35.242667 5.802667-94.122667 15.36-94.122666 29.824v75.989333c23.808-9.514667 55.082667-14.549333 87.168-19.754667C585.301333 919.338667 640 907.818667 640 874.666667v-128a21.333333 21.333333 0 0 1 42.666667 0v128c0 72.106667-89.813333 86.656-162.005334 98.346666-35.157333 5.717333-93.994667 15.232-93.994666 29.653334a21.333333 21.333333 0 0 1-21.333334 21.333333z" p-id="2457"></path><path d="M439.978667 666.282667a21.333333 21.333333 0 0 1-12.501334-4.053334C398.634667 641.365333 384 612.352 384 576c0-88.149333 104.661333-106.709333 205.866667-124.629333 60.501333-10.709333 123.136-21.802667 155.562666-46.677334a21.333333 21.333333 0 0 1 22.570667-2.133333V362.666667a21.333333 21.333333 0 0 1 42.666667 0v128c0 93.482667-113.194667 113.450667-213.12 131.029333-55.978667 9.856-113.792 20.053333-145.877334 41.088a21.162667 21.162667 0 0 1-11.690666 3.498667zM768 441.088c-41.002667 29.354667-106.88 41.002667-170.666667 52.309333-103.082667 18.261333-170.666667 33.834667-170.666666 82.602667 0 17.92 4.906667 31.616 15.701333 42.922667 38.826667-20.053333 91.946667-29.397333 147.797333-39.253334C697.6 560.768 768 544.341333 768 490.666667v-49.578667z" p-id="2458"></path><path d="M571.136 835.456a20.266667 20.266667 0 0 1-4.224-0.426667l-18.901333-3.712C478.805333 818.005333 384 799.744 384 704v-128a21.333333 21.333333 0 0 1 42.666667 0v52.309333a21.248 21.248 0 0 1 25.813333-0.597333c25.045333 18.176 65.066667 25.941333 103.765333 33.493333 59.264 11.477333 126.421333 24.533333 126.421334 85.461334 0 65.024-77.738667 81.92-106.965334 88.32a23.338667 23.338667 0 0 1-4.565333 0.469333zM426.666667 661.632v42.368c0 56.277333 51.242667 70.357333 129.450666 85.418667l14.762667 2.901333c61.141333-13.994667 69.12-31.701333 69.12-45.653333 0-24.021333-34.688-32.512-91.904-43.605334-43.221333-8.405333-87.936-17.109333-120.661333-40.832a9.386667 9.386667 0 0 1-0.768-0.597333z',
}
const title = "Create your seating chart now!"
const maintext = "Click continue and start editing your Seating Chart."
const device_css_map = {
    'WEB': { padding: '0px 80px 80px', width: '', display: 'flex', flexDirection: 'column', color: '#707070', },
    'TABLET': { padding: '0px 16px 16px', width: '', display: 'flex', flexDirection: 'column', color: '#707070', },
    'MOBILE': { padding: '', width: '100%', display: 'flex', flexDirection: 'column', color: '#707070', }
}

function Seatingchart(props) {

    const device = Checkdevice()
    const { token } = Retrieve_personal_info()
    const [firsttime, setFirsttime] = useState(true)
    const [loaded, setLoaded] = useState(true)
    const [sc_ids, setSc_ids] = useState([])
    const [_id, setId] = useState('') // to indicate is ADD or event seating chart id clicked
    const [etype, setEtype] = useState('')
    const [urlhandler, setUrlhandler] = useState('') // event seating chart url handler
    const [quota, setQuota] = useState(0)

    // edit btn modal
    const [passcode, setPasscode] = useState('')
    const [newpasscode, setNewpasscode] = useState('')
    const [editmodal, setEditmodal] = useState(false)

    // for removal of selectionbox
    const [rmvmod, setRmvmod] = useState(false)
    const [rmvindex, setRmvindex] = useState(null)
    const [rmvid, setRmvid] = useState(null)

    // all pages
    const [page, setPage] = useState('NONE') // NONE, CREATE, OPEN (OPEN EXISTING)

    useEffect(() => {
        if (firsttime) {
            try {
                let options = {
                    method: 'POST',
                    url: READ_SC,
                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                }
                axios(options).then((item) => {
                    const { seat_ids, seat_quota, orderids } = item.data
                    reorder(seat_ids && seat_ids.length > 0, seat_ids, orderids);
                    setQuota(seat_quota)
                    setLoaded(true)
                    setPage('NONE')
                }).catch((e) => { props.history.push('/') })
            }
            catch (e) {
                props.history.push('/')
            }
            setFirsttime(false)
        }
    }, [])

    function reorder(gtseatids, seat_ids, orderids) {
        if (gtseatids) {
            // reorder them based on checklist_ids, as db return messy indexed arr
            var new_objs = seat_ids && seat_ids.map(() => []);
            for (let i = 0; i < seat_ids.length; i++) {
                const { _id } = seat_ids[i];
                var index = orderids.indexOf(_id);
                new_objs[index] = seat_ids[i];
            }
            setSc_ids(new_objs);
        }
        else {
            setSc_ids([]);
        }
    }

    function clearFields() {
        setEtype('')
        setUrlhandler('')
        setPasscode('')
    }

    const clickexist = (item, index) => {
        if (item === _id) {
            // uncheck 
            clearFields()
            setId('')
            setPage('NONE')
        }
        else {
            var obj
            for (let i = 0; i < sc_ids.length; i++) {
                if (sc_ids[i]._id === item) {
                    obj = sc_ids[i]
                    break
                }
            }
            const { _id, etype, urlhandler, passcode } = obj
            clearFields()
            setId(_id)
            setEtype(etype)
            setUrlhandler(urlhandler)
            setPasscode(passcode ? passcode : '')
            setPage('OPEN')
        }
    }

    const add = () => {
        setId('')
        setPage('CREATE')
    }

    const updateseq = (new_ids) => { setSc_ids(new_ids); };

    const rmvexist = (item, index) => {
        try {
            let options = {
                method: 'POST',
                url: REMOVE_SINGLESC,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                data: { sc_id: item }
            }
            axios(options).then((item) => {
                const { data } = item
                const { message } = data
                if (message === 'SUCCESS') {
                    setId('')

                    var local_sc_ids = sc_ids.slice()
                    local_sc_ids.splice(index, 1)
                    setSc_ids(local_sc_ids)
                    clearFields()
                }
            }).catch((e) => { props.history.push('/') })
        }
        catch (e) {
            props.history.push('/')
        }
    }

    const lookupclick = '/seatingchartlookup/' + urlhandler + (passcode && passcode.length > 0 ? `/passcode=${passcode}` : '')

    const continueclick = () => {
        props.history.push('seatingchartbuilder/' + _id + '/edit')
    }

    const savepasscode = (newpasscode) => {
        return axios({
            method: 'POST',
            url: USER_EDITSEATPASSCODE,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { newpasscode, passcode, _id }
        }).then((result) => {
            const { data } = result
            if (data.message === 'SUCCESS') {
                setPasscode(newpasscode)
                return 'SUCCESS'
            }
            else {
                return 'UNABLE_SAVE'
            }
        }).catch((e) => { })
    }

    const create = (urlhandler, passcode, etype) => {

        return axios({
            method: 'POST',
            url: CREATE_SC,
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
            data: { urlhandler, passcode, etype }
        }).then((item) => {
            const { data } = item
            const { message } = data
            if (message === 'SUCCESS') {
                setSc_ids([...sc_ids, data.sc])
                setId('')
                setPasscode('')
            }

            return { message, id: data.sc._id } // this will return to Createnew.jsx, then it will call createsuccess and set the id.

        }).catch((e) => props.history.push('/'))
    }

    return <div id='planningedit_root'>
        <div id='planningedit_selectionbox'>
            {loaded
                ? <Selectionbox
                    where={'seatingchart'}
                    onClickexist={clickexist}
                    onRemoveexist={(_id, index) => { setRmvmod(true); setRmvid(_id); setRmvindex(index) }}
                    onAdd={add}
                    updateseq={updateseq}
                    quota={quota}
                    ids={sc_ids}
                    id={_id}
                />
                : null}
            {{
                'NONE': null,
                'OPEN': <Continuepage
                    {...props}
                    from={'seatingchart'}
                    urlhandler={urlhandler}
                    passcode={passcode}
                    itype={etype}
                    lookupclick={lookupclick}
                    continueclick={continueclick}
                    savepasscode={savepasscode}
                    title={'Change Passcode'}
                />,
                'CREATE': <Createnew
                    {...props}
                    from={'seatingchart'}
                    reachquota={quota === sc_ids.length}
                    urlhandler={urlhandler}
                    passcode={passcode}
                    itype={'Wedding'}
                    create={create}
                    createsuccess={(id, urlhandler, passcode, etype) => {
                        setUrlhandler(urlhandler)
                        setPasscode(passcode)
                        setId(id)
                        setEtype(etype)
                        setPage('OPEN')
                    }}
                />
            }[page]}
            {rmvmod
                ? <Modcfm
                    onHide={() => { setRmvmod(false) }}
                    onOk={() => { rmvexist(rmvid, rmvindex); setRmvmod(false) }}
                    onNo={() => { setRmvmod(false) }}
                    txt={'Once you delete this, there is no going back. Link to this Seating Chart will no longer be functional, please be certain.'}
                />
                : null}
        </div>

    </div>
}
export default Seatingchart